import React from 'react';
import { Link } from 'react-router-dom';
interface LogoProps {
  onClick?: () => void;
}
export function Logo({
  onClick
}: LogoProps) {
  return <Link to="/" onClick={onClick} className="group inline-flex flex-col leading-none" aria-label="Qorvessa Executive Partners, home" data-id="element-133" data-mp="y8tjawotphz6">
      <span className="font-serif text-2xl font-semibold tracking-wide text-champagne-100" data-id="element-134" data-mp="ocytnhm6mmmw">Qorvessa</span>
      <span className="mt-1 text-[10px] font-medium uppercase tracking-[0.28em] text-champagne-400" data-id="element-135" data-mp="kbn4teb4u5fr">Executive Partners</span>
    </Link>;
}